export function news() {
  const page = document.querySelector('.toptech-news-page');

  if (!page) {
    return;
  }

  page.querySelectorAll('[data-news-auto-submit]').forEach((field) => {
    field.addEventListener('change', () => {
      field.form.submit();
    });
  });
}
